<script setup>
import { onBeforeUnmount, computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTrack } from 'dashboard/composables';
import { useStore } from 'dashboard/composables/store';
import { CONVERSATION_EVENTS } from 'dashboard/helper/AnalyticsHelper/events';
import { useConversationFilterContext } from './provider.js';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';

import ResponsivePanel from 'dashboard/components-next/overlay/ResponsivePanel.vue';
import ConversationMobileFilter from './ConversationMobileFilter.vue';

const props = defineProps({
  isFolderView: {
    type: Boolean,
    default: false,
  },
  folderName: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['applyFilter', 'updateFolder', 'close']);
const { filterTypes } = useConversationFilterContext();

const filters = defineModel({
  type: Array,
  default: [],
});
const folderNameLocal = ref(props.folderName);

const { t } = useI18n();
const store = useStore();

const resetFilter = () => {
  filters.value = [];
};

const submitFilters = payload => {
  store.dispatch(
    'setConversationFilters',
    useSnakeCase(JSON.parse(JSON.stringify(payload)))
  );
  emit('applyFilter', payload);
  useTrack(CONVERSATION_EVENTS.APPLY_FILTER, {
    appliedFilters: payload.map(filter => ({
      key: filter.attributeKey,
      operator: filter.filterOperator,
      queryOperator: filter.queryOperator,
    })),
  });
};

const updateSavedCustomViewsFromMobile = (payload, name) => {
  emit('updateFolder', payload, name);
};

const filterModalHeaderTitle = computed(() => {
  return !props.isFolderView
    ? t('FILTER.TITLE')
    : t('FILTER.EDIT_CUSTOM_FILTER');
});

onBeforeUnmount(() => emit('close'));
</script>

<template>
  <ResponsivePanel
    :ignore-click-outside="['#toggleConversationFilterButton']"
    :title="filterModalHeaderTitle"
    :close-label="t('GENERAL.CLOSE')"
    show-mobile-title
    panel-class="md:w-[400px]"
    content-class="h-full md:p-4"
    @close="emit('close')"
  >
    <ConversationMobileFilter
      v-model="filters"
      :filter-types="filterTypes"
      :folder-name="folderNameLocal"
      :is-folder-view="props.isFolderView"
      @apply-filter="submitFilters"
      @update-folder="updateSavedCustomViewsFromMobile"
      @clear-filters="resetFilter"
      @close="emit('close')"
    />
  </ResponsivePanel>
</template>
